import { TextChatUserService } from '../text-chat-user/text-chat-user.service';
import { Injectable } from '@angular/core';
import { TextChatUser } from '../xislivechat/models/text-chat-user';
import { DynamicQueryStoreObservableFactory } from 'common/dynamicquery/dynamic-query-store-observable';

@Injectable()
export class TextChatUserStoreFactoryService {

  constructor(private textChatUserService: TextChatUserService,
              private dynamicQueryStoreObservableFactory: DynamicQueryStoreObservableFactory) {
  }

  create(textUserId) {
    if (!textUserId) {
      throw new Error('Missing textUserId');
    }

    const textUser = this.textChatUserService.observeTextChatUserByTextUserId(textUserId);
    return this.dynamicQueryStoreObservableFactory.create(textUser, TextChatUser.comparator);
  }
}
